import { createVNode as _createVNode, renderSlot as _renderSlot, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/static/Cross.png'
import _imports_1 from '@/assets/images/static/Copy.png'


const _hoisted_1 = { class: "popup-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "popup-wrapper__mask" }, null, -1)
const _hoisted_3 = { class: "popup-container" }
const _hoisted_4 = { class: "popup" }
const _hoisted_5 = { class: "popup-header" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = { class: "popup-content" }
const _hoisted_8 = { class: "popup-content__image" }
const _hoisted_9 = { class: "popup-content__title" }
const _hoisted_10 = { class: "popup-content__description" }
const _hoisted_11 = {
  key: 0,
  class: "popup-content__code"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", {
            class: "popup-header__cross",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
          }, [
            _hoisted_6
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("img", {
              src: _ctx.typeList[_ctx.type]
            }, null, 8, ["src"])
          ]),
          _createVNode("div", _hoisted_9, [
            _renderSlot(_ctx.$slots, "title")
          ]),
          _createVNode("div", _hoisted_10, [
            _renderSlot(_ctx.$slots, "description")
          ]),
          (_ctx.isValid(_ctx.modelValue))
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _withDirectives(_createVNode("input", {
                  class: "popup-content__code__input",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelValue = $event)),
                  readonly: ""
                }, null, 512), [
                  [_vModelText, _ctx.modelValue]
                ]),
                _createVNode("img", {
                  class: "popup-content__code__copy",
                  src: _imports_1,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copyKey($event,_ctx.modelValue)))
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", {
          class: "popup-footer",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
        }, "確定")
      ])
    ])
  ]))
}